import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Service, { inject } from '@ember/service';
import { getOwner } from '@ember/application';
import '../lib/utility/ajax.js';
import '@ember/object';
import { sendSocketPageView } from '../lib/utility/currency.js';
import 'moment-timezone';
import { modelVar } from '../lib/utility/models.js';
import '../lib/utility/province.js';
import { untitledDocumentTitle } from '../lib/nv-document-title.js';
import { nuovaOwnsPageScroll } from '../lib/nv-scroll-restore.js';

var _class, _descriptor, _descriptor2;
let SocketTrackerService = (_class = class SocketTrackerService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
  }
  trackPage(model, transition) {
    const applicationController = this._getApplicationController();
    if (!nuovaOwnsPageScroll(document.documentElement)) {
      document.documentElement.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
    const {
      to: toRouteInfo
    } = transition;
    const params = toRouteInfo.params;
    const isView = toRouteInfo.name;
    const openCards = applicationController.openCards;
    let isPresent = openCards.find(i => i.item.id === model.id);
    let obj = null;
    if (!applicationController.isSmallDevice) {
      const orgName = this.session.me?.organization?.name || '';
      let pageTitle = `${orgName} | Beebeeboard`;
      if (['list', 'calendar.index', 'calendar'].includes(toRouteInfo.name)) {
        const modelName = params.model_name || (toRouteInfo.name.includes('calendar') ? 'calendar' : null);
        isPresent = openCards.find(i => i.url === modelName);
        sendSocketPageView(applicationController.socket, modelName, false, null, true);
        let nameToShow = this.session.me?.organization?.[modelName + '_name'] || modelName;
        let translateModelName = false;
        if (modelName === 'calendar') {
          nameToShow = 'calendar';
          translateModelName = true;
        } else if (modelName === 'autofattura') {
          nameToShow = 'self-invoice';
          translateModelName = true;
        }
        obj = {
          url: modelName,
          item: {
            id: null,
            label: nameToShow,
            translateModelName
          },
          modal_name: null,
          itemInfo: modelVar(modelName, true)
        };
        const rawTitle = translateModelName ? this.intl.t(nameToShow) : nameToShow;
        // the list keys are lower case («appuntamenti»): the browser tab reads «Appuntamenti | …»
        const titleName = typeof rawTitle === 'string' && rawTitle ? rawTitle.charAt(0).toLocaleUpperCase() + rawTitle.slice(1) : rawTitle;
        pageTitle = `${titleName} | ${orgName} | Beebeeboard`;
      } else if (model.id && isView === 'view') {
        sendSocketPageView(applicationController.socket, model, false, null, null);
        obj = {
          url: 'view',
          item: model,
          modal_name: params.model_name,
          itemInfo: modelVar(model, false)
        };
        pageTitle = `${this._recordTitle(model)} | ${orgName} | Beebeeboard`;
      }
      document.title = pageTitle;
    }

    // openCards is a @tracked plain array on the application controller:
    // reassign a single property on the held object instead of mutating in place
    let cardsChanged = false;
    const nextCards = [...(openCards || [])];
    if (obj && !isPresent) {
      nextCards.push(obj);
      cardsChanged = true;
    }
    if (nextCards.length > 8) {
      nextCards.shift();
      cardsChanged = true;
    }
    if (cardsChanged) {
      applicationController.openCards = nextCards;
    }
    this._resetUI(applicationController);
  }
  _resetUI(applicationController) {
    // `document.body` is null while the document is being unloaded/replaced.
    // Removing the classes is cosmetic, but the controller state reset below
    // must still run: this method is reached from the `view` route `afterModel`
    // hook, so throwing here aborts the whole route transition.
    document.body?.classList.remove('hide-header', 'modal-open');
    applicationController.setProperties({
      eventPopup: null,
      showCanvasNotification: false,
      showCanvasAccount: false,
      showCanvasMobileMenu: false,
      itemPreview: false,
      modalComponents: []
    });
  }

  /** Browser-tab title of a record page: the model label, or the nuova sentence for an untitled document. */
  _recordTitle(model) {
    const ui = getOwner(this)?.lookup?.('service:ui');
    if (ui?.isNuova && model?.constructor?.modelName === 'invoice') {
      const untitled = untitledDocumentTitle(model, this.intl, this.session.me?.organization);
      if (untitled) return untitled;
    }
    return model.label;
  }
  _getApplicationController() {
    const owner = getOwner(this);
    return owner.lookup('controller:application');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { SocketTrackerService as default };
//# sourceMappingURL=socket-tracker.js.map
